import { createSlice } from "@reduxjs/toolkit";
import type { RootState } from "../app";

// Define a error for the slice state
interface errorState {
  show: boolean;
  severity: string;
  message: string;
  showSuccess: boolean;
}

// Define the initial state using that error
const initialState: errorState = {
  show: false,
  severity: "error",
  message: "",
  showSuccess: false,
};

export const errorSlice = createSlice({
  name: "error",
  // `createSlice` will infer the state error from the `initialState` argument
  initialState,
  reducers: {
    addError: (state, action) => {
      state.show = true;
      state.message = action.payload;
    },
    removeError: (state) => {
      state.show = false;
      state.message = "";
      state.showSuccess = false;
    },
    addSuccessMessage: (state, action) => {
      state.showSuccess = true;
      state.message = action.payload;
    },
  },
});

export const { addError, removeError, addSuccessMessage } = errorSlice.actions;

// Other code such as selectors can use the imported `RootState` error

export const getErrorMessage = (state: RootState) => state.error.message;
export const isError = (state: RootState) => state.error.show;
export const isSuccess = (state: RootState) => state.error.showSuccess;
export const errorColor = (state: RootState) => state.error.severity;

export default errorSlice.reducer;
